// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2PePY","col":"styles_col__2nXSb","fulfillmentStatus":"styles_fulfillmentStatus__2VhC4","emailCol":"styles_emailCol__37T5x"};